var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 12",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.94 11.78a.495.495 0 0 1-.353-.147.503.503 0 0 1 0-.706L4.933 6.58a.82.82 0 0 0 0-1.16L.587 1.073a.503.503 0 0 1 0-.706.503.503 0 0 1 .706 0L5.64 4.713c.34.34.533.8.533 1.287 0 .487-.186.947-.533 1.287l-4.347 4.346a.524.524 0 0 1-.353.147Z",
    fill: "currentColor"
  })));
};
export { SvgChevron as ReactComponent };